import { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { useLocation, useNavigate } from "react-router-dom";
import { AgentPage } from "./pages/AgentPage";

const mobileQuery = "(max-width: 780px)";

export function AgentOverlay() {
  const location = useLocation();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const panelRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const toggle = () => {
      if (window.matchMedia(mobileQuery).matches) {
        navigate("/assistente");
        return;
      }
      setOpen((value) => !value);
    };
    window.addEventListener("ja:agent-toggle", toggle);
    return () => window.removeEventListener("ja:agent-toggle", toggle);
  }, [navigate]);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    window.dispatchEvent(new CustomEvent("ja:agent-open-change", { detail: open }));
  }, [open]);

  useEffect(() => {
    if (!open) return;
    const previousFocus = document.activeElement as HTMLElement | null;
    const focusFrame = window.requestAnimationFrame(() => panelRef.current?.focus());
    const closeOnEscape = (event: KeyboardEvent) => {
      if (event.key === "Escape") setOpen(false);
    };
    document.addEventListener("keydown", closeOnEscape);
    return () => {
      window.cancelAnimationFrame(focusFrame);
      document.removeEventListener("keydown", closeOnEscape);
      previousFocus?.focus();
    };
  }, [open]);

  if (!open || location.pathname.startsWith("/assistente")) return null;
  return createPortal(
    <section
      ref={panelRef}
      className="agent-floating-panel"
      role="dialog"
      aria-label="Assistente JA"
      tabIndex={-1}
    >
      <AgentPage presentation="panel" onClose={() => setOpen(false)} />
    </section>,
    document.body,
  );
}
